import template from './contract_type.html'
import controller from './contract_type.controller'
import './contract_type.scss'

const contractTypeComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default contractTypeComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract_type/contract_type.component.js